module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"map":"Карта"},"en":{"map":"Map"}}')
  delete Component.options._Ctor
}
